export default __webpack_public_path__ + "static/media/email.d8fbca4a.svg";